import {IBoxes} from "src/store/models";
import {addNewElement} from "src/utils/utils";

export const changeBox = (state: IBoxes, elementId: string, parentId: string, targetId: string) => {
    return {
        ...state,
        [parentId]: {
            ...state[parentId],
            fruitsIds: state[parentId].fruitsIds.filter(fruit => fruit !== elementId)
        },
        [targetId]: {
            ...state[targetId],
            fruitsIds: addNewElement(state[targetId].fruitsIds, elementId)
        }
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/changing/changeBoxReducer.ts